// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"ac051b39","2855":"ac051b39","4105":"1f08cf17","6829":"ac051b39"}[chunkId] + ".chunk.css";
};